import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../components/layouts/Layout';
import SEO from '../components/seo';

import scbz_logo from '../images/logos/scbz.png';
import '../components/legal/style.scss';

export const Legal = ({ user, notification, actions }) => {
    return (
        <Layout user={user} notification={notification} actions={actions}>
            <SEO title="Legal Notices" />
            <div className="legal">
                <div className="upper-content">
                    <h1 className="title-section text-center">Legal Notices</h1>
                </div>
                <div className="lower-content">
                    <div className="inner-area">
                        <div className="media">
                            <div className="media-left media-middle">
                                <img
                                    alt="Second Chance Bonus Zone® logo"
                                    data-align="left"
                                    src={scbz_logo}
                                />
                            </div>

                            <div className="media-body media-middle">
                                Second Chance Bonus Zone®
                                (secondchancebonuszone.com) is a registered
                                trademark of MDI Entertainment, A Scientific
                                Games Company.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Legal);
